<alaris-card>
	@if (tRows.length > 0 || tRows.length === 0 && state.isFiltersApplied) {
		<div class="table-management">
			<div class="left">
				<span class="total"> {{ totalTitle | translate }}: {{ total }} </span>
				<button (click)="editTableFilter()" alaris-button bType="outline" size="lg">
					<alaris-icon name="icon-filter-vertical"></alaris-icon>
					{{ enableButtons.filters.title | translate }}
					@if (state.isFiltersApplied) {
						<div class="indicator"></div>
					}
				</button>
			</div>
			<div class="right">
				<button (click)="refresh()" alaris-button bType="outline" size="lg">
					<alaris-icon name="icon-refresh-clock-wise"></alaris-icon>
					{{ 'actions.refresh_page' | translate }}
				</button>
				<button (click)="export()" [disabled]="!!(exporting$ | async) || !this.user.allowed(['camara_rules.edit'])" alaris-button bType="outline" size="lg">
					@if (exporting$ | async) {
						<alaris-spinner></alaris-spinner>
					} @else {
						<alaris-icon name="icon-export"></alaris-icon>
					}
					{{ 'gl.export' | translate }}
				</button>
				<button (click)="edit()" alaris-button bType="primary" size="lg" [disabled]="!this.user.allowed(['camara_rules.edit'])">
					<alaris-icon class="in-primary" name="icon-plus"></alaris-icon>
					{{ 'camara_rules.create_rule' | translate }}
				</button>
			</div>
		</div>
	}
	<div [alarisLoading]="loading$" alarisHorizontalOverflow class="content">
		@if (tRows.length === 0 && !state.isFiltersApplied) {
			<app-empty-table
					type="camara-rules"
					[disabled]="!this.user.allowed(['camara_rules.edit'])"
					(newCamaraRule)="edit()">
			</app-empty-table>
		} @else {
			<alaris-table
					(filtersChange)="_applyFilter($event)"
					(sortingChange)="_applySorting($event)"
					[filters]="state.filters()"
					[dblClickRowAction]="dblClickRowAction.bind(this)"
					[dropDownRowActions]="dropDownRowActions"
					[rowActions]="rowActions"
					[tHeaders]="tHeaders()"
					[tRows]="tRows"
					[templates]="{ clientList: clientListTemplate, ruleType: ruleTypeTemplate,
					    createdBy: createdByTemplate, lastUpdated: lastUpdatedTemplate }"
					[resizable]="resizable"
					alarisOverflowFader>
			</alaris-table>
		}
	</div>
	<div class="footer">
		<alaris-pagination
				(page)="_pageChange($event)"
				[activePage]="activePage"
				[class.without-table-bar]="selection !== null && selection.length === 0"
				[hidden]="total === 0"
				[pageSizeOptions]="pageSizeOptions"
				[pageSize]="pageSize"
				[total]="total"
				class="pagination">
		</alaris-pagination>
	</div>
</alaris-card>

<ng-template #clientListTemplate [alarisCellCtx]="tRows[0]" let-data="data" let-key="key">
	<div class="tagFilter">
		@if (data.clientList && data.clientList.length) {
			@for (clientId of data.clientList; track clientId) {
				<alaris-tag>{{ getClientNames([clientId]) }}</alaris-tag>
			}
		} @else {
			<span>{{ 'gl.all' | translate }}</span>
		}
	</div>
</ng-template>

<ng-template #ruleTypeTemplate [alarisCellCtx]="tRows[0]" let-data="data" let-key="key">
	<span>{{ getRuleTypeLabel(data.ruleType) || '-' }}</span>
</ng-template>

<ng-template #createdByTemplate [alarisCellCtx]="tRows[0]" let-data="data" let-key="key">
	<span>{{ data.createdBy || '-' }}</span>
</ng-template>

<ng-template #lastUpdatedTemplate let-data="data" [alarisCellCtx]="tRows[0]" let-key="key">
	<span>{{ formatDate(data.lastUpdated) }}</span>
</ng-template>